import { Routes, Route, Navigate } from 'react-router-dom';

import { allowedModules, DEFAULT_TENANT_ID, MODULES } from 'common/constants';
import localStorageWrapper from 'common/loginUtils/local-storage-wrapper';

import Auth from '../pages/Auth/Auth';
import LandingPage from '../pages/LandingPage/LandingPage';
import PageNotFound from '../pages/PageNotFound/PageNotFound';
import UnauthorizedPage from '../pages/UnauthorizedPage/Unauthorized';

import PrivateRoute from './PrivateRoute';
import RRCPDashboardWrapper from './rrcp-dashboard-wrapper';

const getTenantIdFromPath = () =>
	window.location.pathname.split('/')[1] || DEFAULT_TENANT_ID;
const getTenantId = () =>
	localStorageWrapper.getStorageItem('tenantId') || DEFAULT_TENANT_ID;

const urlTenantId = getTenantIdFromPath();
const storedTenantId = getTenantId();

if (storedTenantId !== urlTenantId) {
	localStorageWrapper.setStorageItem(
		'tenantId',
		urlTenantId || DEFAULT_TENANT_ID,
	);
} else {
	localStorageWrapper.setStorageItem('tenantId', storedTenantId);
}
const tenantId = getTenantId() || DEFAULT_TENANT_ID;
const tenantUrl = `/${tenantId}`;
const Paths = () => (
	<Routes>
		<Route path="/" element={<Navigate to={tenantUrl} />} />
		<Route path={`${tenantUrl}/*`} element={<InsideRoutes />} />
	</Routes>
);
const InsideRoutes = () => (
	<Routes>
		<Route path="/" element={<LandingPage />} />
		<Route path="/callback" element={<Auth />} />
		<Route
			element={
				<PrivateRoute allowedModules={[MODULES.HOME, ...allowedModules]} />
			}
		>
			<Route path="*" element={<RRCPDashboardWrapper />} />
		</Route>
		<Route
			element={
				<PrivateRoute allowedModules={[MODULES.HOME, ...allowedModules]} />
			}
		/>
		<Route path="/unauthorized" element={<UnauthorizedPage />} />
		<Route path="*" element={<PageNotFound />} />
	</Routes>
);
export default Paths;
